









































































import { Vue, Component } from 'vue-property-decorator';
import ItemTable from '@/components/common/ItemTable.vue';
import {
  GetAccumulationsPaymentsPaymentNoMembersRequest,
  GetMemberGradesRequest,
  GetMemberGroupsRequest,
  GetAccumulationsPaymentsPaymentNoRequest,
} from 'supporter';
import { i18nInObjectList } from '@/utils/i18n';
import { ncpPopup } from '@/utils/commonUtils';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import TrTargetGradeGroup from '@/components/member/TrTargetGradeGroup.vue';

@Component({
  components: {
    TrTargetGradeGroup,
    ExcelCreateButton,
    ItemTable,
  },
})
export default class PaymentListPopup extends Vue {
  private paymentSummary: any = {
    mallName: null,
    paymentCount: null,
    amount: null,
    payTotal: null,
    memberGrade: null,
    notificationDateTime: null,
    payMemberGroup: null,
    paymentDateTime: null,
    requestDateTime: null,
    targetType: null,
  };

  private paymentMembersList: any = [];
  private totalCount: number = 0;
  private mallNo: any = '';
  private contentBottomOption: any = {
    haveConfigBtn: true,
    haveExcelDownBtn: false,
    excelDownInfo: {
      nameDateFormat: 'YYYYMMDD_HHmmss',
      fileName: 'accumulation_payment_member',
      columns: {
        memberNo: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_NO',
        memberName: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_NAME',
        mallName: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MALL_NAME',
        memberId: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_ID',
        memberGradeName: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_GRADE_NAME',
        memberGroupNames: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_GROUP_NAMES',
        lastLogin: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_LAST_LOGIN',
        appPushAgreed: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_NOTIFICATION',
        smsAgreeYn: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_SMS_AGREE_YN',
        directMailAgreeYn: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_DIRECT_MALL_AGREE_YN',
      },
      formatters: {
        lastLogin: function(data: any): any {
          if (!data.value) {
            return '-';
          }
          return data.value;
        },
        appPushAgreed: (data: any): any => {
          if (data.row.marketingAgreement.appPushAgreed) {
            return 'Y';
          } else {
            return 'N';
          }
        },
        smsAgreeYn: (data: any): any => {
          if (data.row.marketingAgreement.smsAgreed) {
            return 'Y';
          } else {
            return 'N';
          }
        },
        directMailAgreeYn: (data: any): any => {
          if (data.row.marketingAgreement.emailAgreed) {
            return 'Y';
          } else {
            return 'N';
          }
        },
      },
    },
  };
  private size: number = 30;
  private hasGrade: boolean = false;
  private hasGroup: boolean = false;
  private gradesContent: any = [];
  private groupsContent: any = [];
  private useGradeAndGroup: boolean = false;
  private useAll: boolean = false;

  private paymentNo: string = this.$route.query.requestNo as string;
  private paramsExcel = {
    mallNo: Number(this.$route.query.mallNo),
    searchType: 'ALL',
  };

  private created(): void {
    this.mallNo = this.$route.query.mallNo;
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private mounted(): void {
    $('body').on('click', '.openMemberPopup', $.proxy(this.clickMemberPopup, this));
  }
  private destroyed(): void {
    $('body').off('click', '.openMemberPopup', $.proxy(this.clickMemberPopup, this));
  }

  private getMemberGrades(value: any): void {
    let request: GetMemberGradesRequest = {
      params: {
        mallNo: this.$route.query.mallNo as any,
      },
    };
    this.$api.getMemberGrades(request).then((res: any): any => {
      this.paymentSummary.memberGrade = '';
      this.hasGrade = false;
      res.data.map((item: any): any => {
        if (item.no === value) {
          this.paymentSummary.memberGrade = item.name;
          this.hasGrade = true;
        }
      });
    });
  }
  private getMemberGoups(value: any): void {
    let request: GetMemberGroupsRequest = {
      params: {
        mallNo: this.$route.query.mallNo as any,
      },
    };
    this.$api.getMemberGroups(request).then((res: any): any => {
      this.paymentSummary.payMemberGroup = '';
      this.hasGroup = false;
      res.data.map((item: any): any => {
        if (item.no === value) {
          this.paymentSummary.payMemberGroup = item.name;
          this.hasGroup = true;
        }
      });
    });
  }
  private clickMemberPopup(e: any): void {
    const memberno = $(e.target).attr('memberNo');
    const title: any = this.$t('ACCUMULATION_PAYMENT_LIST_MEMBER_POPUP_TITLE');
    ncpPopup(`/member/popup/crm/${memberno}?tabName=benefit`, title, 950, 700);
  }
  private getPaymentDdtail(page: any): void {
    let paymentRequest: GetAccumulationsPaymentsPaymentNoRequest = {
      pathParams: {
        paymentNo: this.$route.query.requestNo as string,
      },
      params: {
        mallNo: Number(this.$route.query.mallNo),
      },
    };
    this.$api.getAccumulationsPaymentsPaymentNo(paymentRequest).then((res): any => {
      this.getPaymentSummary(res.data);
      if (this.useGradeAndGroup) {
        this.handleMemberAll(page, 'gradeAndGroup');
      } else if (this.useAll) {
        this.handleMemberAll(page, 'all');
      } else {
        this.handlePaymenNoMembers(page);
      }
    });
  }
  private getPaymentSummary(data: any): any {
    this.paymentSummary.mallName = this.$route.query.mallName;
    this.formatterPaymentSummary(data);
  }
  private formatterPaymentSummary(data: any): any {
    this.useGradeAndGroup = false;
    this.useAll = false;
    this.groupsContent = [];
    this.gradesContent = [];
    if (data.targets.length === 1 && data.targets[0].type === 'ALL') {
      this.useAll = true;
      this.paymentSummary.memberGrade = this.$t('ACCUMULATION_PAYMENT_LIST_ALL_TARGETS_TAG');
      this.paymentSummary.payMemberGroup = this.$t('ACCUMULATION_PAYMENT_LIST_ALL_TARGETS_TAG');
    }
    if (data.targets.length === 1) {
      this.paymentSummary.targetType = data.targets[0].type;
    }
    const getTarget = (targetType: 'GRADE' | 'GROUP'): any =>
      data.targets.find(({ type }: any): boolean => type === targetType);
    const targets: any = [
      getTarget('GRADE') ?? { type: 'GRADE', values: ['-1'] },
      getTarget('GROUP') ?? { type: 'GROUP', values: ['-1'] },
    ];
    targets.map((item: any): any => {
      if (item.type === 'GRADE' && item.values[0] !== '-1') {
        this.getMemberGrades(item.values[0]);
        this.gradesContent = item.values;
        this.useGradeAndGroup = true;
      }
      if (item.type === 'GRADE' && item.values[0] === '-1') {
        this.paymentSummary.memberGrade = this.$t('ACCUMULATION_PAYMENT_LIST_ALL_TARGETS_TAG');
      }
      if (item.type === 'GROUP' && item.values[0] !== '-1') {
        this.getMemberGoups(item.values[0]);
        this.groupsContent = item.values;
        this.useGradeAndGroup = true;
      }
      if (item.type === 'GROUP' && item.values[0] === '-1') {
        this.paymentSummary.payMemberGroup = this.$t('ACCUMULATION_PAYMENT_LIST_ALL_TARGETS_TAG');
      }
    });
    this.paymentSummary.amount = data.amount.toLocaleString();
    this.paymentSummary.payTotal = (data.amount * data.paymentCount).toLocaleString();
    if (data.notificationDateTime) {
      this.paymentSummary.notificationDateTime = data.notificationDateTime.substring(0, 16);
    }

    if (data.paymentDateTime) {
      this.paymentSummary.paymentDateTime = data.paymentDateTime.substring(0, 16);
    }
    this.paymentSummary.paymentCount = data.paymentCount;

    if (data.requestDateTime) {
      this.paymentSummary.requestDateTime = data.requestDateTime.substring(0, 16);
    }
  }
  private search(page: number = 1, size: number): void {
    if (size) {
      this.size = size;
    }
    this.getPaymentDdtail(page);
  }
  private handlePaymenNoMembers(page: any): void {
    let paymentRequest: GetAccumulationsPaymentsPaymentNoMembersRequest = {
      pathParams: {
        paymentNo: this.$route.query.requestNo as any,
      },
      params: {
        mallNo: this.$route.query.mallNo as any,
      },
    };
    paymentRequest.params.page = page;
    paymentRequest.params.pageSize = this.size;
    this.$api.getAccumulationsPaymentsPaymentNoMembers(paymentRequest).then((res: any): any => {
      this.$nextTick((): any => {
        this.paymentMembersList = [];
        this.paymentMembersList = res.data.contents;
        this.paymentMembersList = [...this.formatterContent(this.paymentMembersList)];
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      });
      this.paymentSummary.paymentCount = res.data.totalCount;
    });
  }
  private handleMemberAll(page: any, tag: string): void {
    let memberRequest: any = {
      params: {
        mallNo: this.$route.query.mallNo as any,
        page: page,
        pageSize: this.size,
      },
    };
    if (tag === 'all') {
      memberRequest.params.searchType = 'ALL';
    } else {
      let theGroups: any = '';
      let theGrades: any = '';
      if (this.groupsContent.length > 0) {
        theGroups = this.groupsContent.join(',');
      } else {
        theGroups = null;
      }
      if (this.gradesContent.length > 0) {
        theGrades = this.gradesContent.join(',');
      } else {
        theGrades = null;
      }
      memberRequest.params.gradeNos = theGrades;
      memberRequest.params.groupNos = theGroups;
    }

    this.$api.getMembers(memberRequest).then((res: any): any => {
      this.paymentSummary.paymentCount = res.data.totalCount;
      this.paymentMembersList = [];
      this.paymentMembersList = res.data.contents;
      this.memberFormatterList(this.paymentMembersList);
      this.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.perPage = this.size;
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
    });
  }
  private memberFormatterList(arr): any {
    if (arr.length === 0) {
      return;
    }
    arr.map((item: any): any => {
      let obj: any = {};
      obj.appPushAgreed = item.appPushAgreed;
      obj.emailAgreed = item.directMailAgreed;
      obj.smsAgreed = item.smsAgreed;
      item.marketingAgreement = obj;
      item.mallName = this.$route.query.mallName;
      item.memberName = item.name;
      item.memberId = item.id;
      if (item.lastLoginDateTime) {
        item.lastLogin = item.lastLoginDateTime.substring(0, 16);
      }

      // item.memberGradeName = item.grade.name;
      if (item.groups.length > 0) {
        let name: any = '';
        let nameArr: any = item.groups.map((mem: any): any => {
          return mem.name;
        });
        name = nameArr.join(' | ');
        this.$set(item, 'memberGroupNames', name);
      } else {
        this.$set(item, 'memberGroupNames', '-');
      }
      if (!item.grade) {
        this.$set(item, 'memberGradeName', '-');
      } else {
        this.$set(item, 'memberGradeName', item.grade.name);
      }
    });
  }

  private formatterContent(data: any): any {
    if (!data.length) {
      let arr: any = [];
      return arr;
    }
    data.map((item: any): any => {
      item.mallNo = this.$route.query.mallNo;
      this.$set(item, 'mallName', this.$route.query.mallName);
      if (item.memberGroups.length) {
        let name: any = '';
        let nameArr: any = item.memberGroups.map((mem: any): any => {
          return mem.name;
        });
        name = nameArr.join(' | ');
        this.$set(item, 'memberGroupNames', name);
      } else {
        this.$set(item, 'memberGroupNames', '-');
      }
      if (!item.memberGrade) {
        this.$set(item, 'memberGradeName', '-');
      } else {
        this.$set(item, 'memberGradeName', item.memberGrade.name);
      }
    });

    return data;
  }
  private gridProps = {
    options: {
      header: {
        height: 33,
      },
      columnOptions: {
        minWidth: 50,
        resizable: true,
      },

      rowHeight: 31,
      displayRowCount: 15,
      isInitialRequest: true,
      useClientSort: false,

      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
      },
      copyOptions: {
        useFormattedValue: true,
      },
    },

    columns: [
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_NO',
        name: 'memberNo',
        align: 'center',
        minWidth: 85,
        formatter: function(data: any): any {
          return `<a href="javascript:;" memberNo="${data.value}" class="openMemberPopup">${data.value} </a>`;
        },
        copyOptions: {
          useFormattedValue: false,
        },
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_NAME',
        name: 'memberName',
        align: 'center',
        minWidth: 70,
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MALL_NAME',
        name: 'mallName',
        align: 'center',
        minWidth: 100,
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_ID',
        name: 'memberId',
        align: 'center',
        minWidth: 85,
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_GRADE_NAME',
        name: 'memberGradeName',
        align: 'center',
        minWidth: 100,
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_MEMBER_GROUP_NAMES',
        name: 'memberGroupNames',
        align: 'center',
        minWidth: 100,
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_LAST_LOGIN',
        name: 'lastLogin',
        align: 'center',
        minWidth: 120,
        formatter: function(data: any): any {
          if (!data.value) {
            return '-';
          }
          return data.value;
        },
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_NOTIFICATION',
        name: 'appPushAgreed',
        align: 'center',
        minWidth: 60,
        formatter: (data: any): any => {
          if (data.row.marketingAgreement.appPushAgreed) {
            return 'Y';
          } else {
            return 'N';
          }
        },
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_SMS_AGREE_YN',
        name: 'smsAgreeYn',
        align: 'center',
        minWidth: 60,
        formatter: (data: any): any => {
          if (data.row.marketingAgreement.smsAgreed) {
            return 'Y';
          } else {
            return 'N';
          }
        },
      },
      {
        header: 'ACCUMULATION_PAYMENT_LIST_TABLE_HEADER_DIRECT_MALL_AGREE_YN',
        name: 'directMailAgreeYn',
        align: 'center',
        minWidth: 60,
        formatter: (data: any): any => {
          if (data.row.marketingAgreement.emailAgreed) {
            return 'Y';
          } else {
            return 'N';
          }
        },
      },
    ],
  };
}
